import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
export const selectWithRatesRenderer = (
    value,
    rates,
    name,
    fieldUpdateHandler,
) => {
    const activeRates = rates?.filter((rate) => rate.active);
    if (activeRates?.length > 0) {
        let values = [{ name: "Отсутствует", id: null }];
        values = activeRates ? values.concat(activeRates) : values;
        const options = values.map((rate, idx) => (
            <MenuItem key={rate.id + "-" + idx + rates?.length} value={rate.id}>
                {rate.name}
            </MenuItem>
        ));
        return (
            <Select
                value={value ?? values[0].id}
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
            >
                {options}
            </Select>
        );
    }
};
